import type { Shape } from './en';
import type { questionnairesDe } from './questionnaires.de';

export const questionnairesEn: Shape<typeof questionnairesDe> = {
  title: 'Questionnaires',
  description:
    'Templates for the questions on records. New records take over the questions of a template, existing ones keep theirs.',
  empty: 'No template yet.',
  default: 'Default',
  inactive: 'Inactive',
  questionCount_one: '{{count}} question',
  questionCount_other: '{{count}} questions',
  add: 'New template',
  loadDefaults: 'Load default content',
  defaultsLoaded_one: '{{count}} template loaded',
  defaultsLoaded_other: '{{count}} templates loaded',
  defaultsNone: 'There are no further default templates.',
  actions: 'Actions for “{{name}}”',
  edit: 'Edit',
  copy: 'Copy',
  makeDefault: 'Make default',
  delete: 'Delete',
  moveUp: 'Move “{{name}}” up',
  moveDown: 'Move “{{name}}” down',
  name: 'Name',
  createTitle: 'New template',
  create: 'Create',
  created: 'Template created',
  copyTitle: 'Copy template',
  copyName: '{{name}} (copy)',
  copied: 'Template copied',
  defaultSet: '“{{name}}” is now the default template',
  deleteTitle: 'Delete “{{name}}”?',
  deleteDescription: 'Records that started with this template keep their questions and answers.',
  deleted: 'Template deleted',
  errors: {
    'template-name-taken': 'A template with this name already exists.',
    'questionnaire-templates-limit': 'A questionnaire cannot have more than 100 templates.',
    'order-incomplete': 'The templates have changed in the meantime. Please sort again.',
  },
  types: {
    text: 'Text',
    number: 'Number',
    'yes-no': 'Yes or no',
    date: 'Date',
    choice: 'Choice',
  },
  editor: {
    template: 'Template',
    active: 'Active',
    activeHint: 'New records only offer active templates.',
    isDefault: 'Default template',
    isDefaultHint: 'New records start with this template.',
    questions: 'Questions',
    questionsHint: 'They appear in the form in this order. Existing records keep their questions.',
    noQuestions: 'No question yet.',
    question: 'Question {{number}}',
    label: 'Question',
    type: 'Kind of answer',
    options: 'Options',
    option: 'Option',
    addOption: 'Add option',
    optionRow: 'Option {{number}}',
    removeOption: 'Remove option {{number}}',
    noOptions: 'No option yet.',
    optionsRequired: 'Enter at least one option.',
    optionRepeats: '“{{option}}” is in the list twice.',
    preset: 'Preset',
    presetHint: 'Already stands as the answer in the form of new records.',
    presetPlaceholders:
      'Already stands as the answer in the form of new records. The STAW App fills in placeholders from the record.',
    numberInvalid: 'Please enter a number.',
    insertPlaceholder: 'Insert placeholder',
    help: 'Help text',
    helpHint: 'Shown in the form below the question.',
    required: 'Required question',
    addQuestion: 'Add question',
    removeQuestion: 'Remove question {{number}}',
    moveUp: 'Move question {{number}} up',
    moveDown: 'Move question {{number}} down',
    invalid: 'Please check the marked entries.',
    unsaved: 'Unsaved changes',
    discard: 'Discard',
    save: 'Save',
    saved: 'Template saved',
  },
  form: {
    none: 'No answer',
    yes: 'Yes',
    no: 'No',
    numberInvalid: 'Please enter a number.',
    empty: 'No questions yet',
    emptyHint: 'Load a template or add custom questions.',
    loadTemplate: 'Load template',
    noTemplates: 'No template available',
    templatesUnavailable: 'Without a connection, no templates are on the device.',
    loaded_one: '{{count}} question added',
    loaded_other: '{{count}} questions added',
    nothingNew: 'All questions of the template are already there.',
    addQuestion: 'Add question',
    addTitle: 'Add a custom question',
    addDescription: 'Applies to this record only, the template stays as it is.',
    add: 'Add',
    own: 'Custom question',
    removeQuestion: 'Remove “{{label}}”',
    removeTitle: 'Remove the question “{{label}}”?',
    removeDescription: 'Its answer is removed with it.',
    removeTemplateDescription:
      'Its answer is removed with it. “Load template” adds the question again.',
    remove: 'Remove',
    answered: '{{answered}} of {{total}} answered',
    template: 'Template: {{name}}',
  },
  view: {
    unanswered: 'no answer',
    empty: 'No answers.',
  },
  select: {
    placeholder: 'Choose template',
    loading: 'Loading templates …',
    none: 'No template available',
  },
};
